import { API2_HOST } from '../../helpers/urlHelper';
import axios from 'axios';
axios.defaults.withCredentials = true;

const STAGE_GROUPED = {
  Beginning: [0, 1, 2, 3, 4, 7],
  Mid: [9, 12, 13, 14, 15, 16],
  EOL: [11, 17, 18, 25, 26, 19, 20, 28],
  RTL: [68, 71, 73]
};

// Hàm tính %
const calculatePercentage = (num, total) => {
  if (!total || total === 0) return 0;
  return (num / total) * 100;
};

export async function getRoutes() {
  const url = `${API2_HOST}/eva-despatch-summaries/get-routes`;
  try {
    const res = await axios.get(url);
    const data = res.data?.data;
    return data;
  } catch (err) {
    console.error('Error fetching getRoutes:', err);
    return null;
  }
}

// --- MAIN SERVICE FUNCTION ---
export async function getDespatchSummary(date, routes = '') {
  const routesParam = routes ? `&routes=${routes}` : '';
  //   const url = `${API2_HOST}/v1/eva-despatch-summaries/get-despatch-summary?date=${date}`;
  const url = `${API2_HOST}/eva-despatch-summaries/get-despatch-summary?date=${date}${routesParam}`;

  try {
    const res = await axios.get(url);
    const data = res.data?.data;
    console.log(res);
    if (!Array.isArray(data)) return { despatch: [], stillage: [] };

    const despatch = transformData(data, false);
    const stillage = transformData(data, true);

    return { despatch, stillage };
  } catch (err) {
    console.error('Error fetching despatch summary:', err);
    return { despatch: [], stillage: [] };
  }
}

function transformData(data, isStillageSummary = false) {
  return data.map(route => buildEachRouteSummary(route, isStillageSummary));
}
function buildEachRouteSummary(route, isStillageSummary) {
  if (!route?.items?.length) return null;

  const getCount = filterFn => route.items.filter(filterFn).length;

  const totals = {
    frames: getCount(
      i => i.frameId > 0 && (isStillageSummary ? i.isDeliveryOnStillage : true)
    ),
    ancills: getCount(
      i =>
        i.boxId > 0 &&
        i.boxType === 1 &&
        (isStillageSummary ? i.isDeliveryOnStillage : true)
    ),
    boxes: getCount(
      i =>
        i.boxId > 0 &&
        i.boxType === 2 &&
        (isStillageSummary ? i.isDeliveryOnStillage : true)
    ),
    weldedCills: getCount(
      i =>
        i.boxId > 0 &&
        i.boxType === 3 &&
        (isStillageSummary ? i.isDeliveryOnStillage : true)
    ),
    oneOffExtras: getCount(
      i =>
        i.boxId > 0 &&
        i.boxType === 5 &&
        (isStillageSummary ? i.isDeliveryOnStillage : true)
    )
  };

  const stages = {
    framesRTL: getCount(
      i =>
        i.frameId > 0 &&
        STAGE_GROUPED.RTL.includes(i.stageId) &&
        (isStillageSummary ? i.isDeliveryOnStillage : true)
    ),
    boxesRTL: getCount(
      i =>
        i.boxId > 0 &&
        i.boxType === 2 &&
        STAGE_GROUPED.RTL.includes(i.stageId) &&
        (isStillageSummary ? i.isDeliveryOnStillage : true)
    ),
    ancillsRTL: getCount(
      i =>
        i.boxId > 0 &&
        i.boxType === 1 &&
        STAGE_GROUPED.RTL.includes(i.stageId) &&
        (isStillageSummary ? i.isDeliveryOnStillage : true)
    ),
    weldedCillsRTL: getCount(
      i =>
        i.boxId > 0 &&
        i.boxType === 3 &&
        STAGE_GROUPED.RTL.includes(i.stageId) &&
        (isStillageSummary ? i.isDeliveryOnStillage : true)
    ),
    oneOffExtrasRTL: getCount(
      i =>
        i.boxId > 0 &&
        i.boxType === 5 &&
        STAGE_GROUPED.RTL.includes(i.stageId) &&
        (isStillageSummary ? i.isDeliveryOnStillage : true)
    ),
    framesAtBeginning: getCount(
      i =>
        i.frameId > 0 &&
        STAGE_GROUPED.Beginning.includes(i.stageId) &&
        (isStillageSummary ? i.isDeliveryOnStillage : true)
    ),
    framesAtMid: getCount(
      i =>
        i.frameId > 0 &&
        STAGE_GROUPED.Mid.includes(i.stageId) &&
        (isStillageSummary ? i.isDeliveryOnStillage : true)
    ),
    framesAtEOL: getCount(
      i =>
        i.frameId > 0 &&
        STAGE_GROUPED.EOL.includes(i.stageId) &&
        (isStillageSummary ? i.isDeliveryOnStillage : true)
    )
  };

  const percentages = {
    framesRTL: calculatePercentage(stages.framesRTL, totals.frames),
    boxesRTL: calculatePercentage(stages.boxesRTL, totals.boxes),
    ancillsRTL: calculatePercentage(stages.ancillsRTL, totals.ancills),
    weldedCillsRTL: calculatePercentage(
      stages.weldedCillsRTL,
      totals.weldedCills
    ),
    oneOffExtrasRTL: calculatePercentage(
      stages.oneOffExtrasRTL,
      totals.oneOffExtras
    ),
    framesAtBeginning: calculatePercentage(
      stages.framesAtBeginning,
      totals.frames
    ),
    framesAtMid: calculatePercentage(stages.framesAtMid, totals.frames),
    framesAtEOL: calculatePercentage(stages.framesAtEOL, totals.frames)
  };

  const groupByJobNo = Object.groupBy(
    route.items.filter(j => j.isDeliveryOnStillage),
    ({ jobNo }) => jobNo
  );

  const groupByStillageNo = Object.groupBy(
    route.items.filter(s => s.stillageNo > 0),
    ({ stillageNo }) => stillageNo
  );

  return {
    route: route.key,
    isStillageSummary,
    totals,
    stages,
    percentages,
    stillageNos: groupByStillageNo,
    numbOfJobs: groupByJobNo
  };
}
